import React, { useState, useEffect } from 'react';
import PageRenderer from '../components/renderer/PageRenderer';
import SettingsLoader from '../components/common/SettingsLoader';
import { useAuth0 } from '@auth0/auth0-react';
import { apiPath } from "../config";
import { ToastContainer } from 'react-toastify';
import { Container, Row } from 'react-bootstrap';
import SimpleHeader from '../components/SimpleHeader';
import MainAppWrap from '../Layout/MainAppWrap';
import Footer from '../components/Footer';

interface Schema {
    header?: {
        logo_url?: string;
        title?: string;
    };
    tabs?: Array<{
        name?: string;
        id?: string;
        title?: string;
        card_list?: Array<{
            title?: string;
            [key: string]: any;
        }>;
        [key: string]: any;
    }>;
    [key: string]: any;
}

const ResponseList: React.FC = () => {
    const { user, getIdTokenClaims } = useAuth0();
    
    const [schema, setSchema] = useState<Schema | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isChatOpen] = useState<boolean>(false);
    const [activeTab, setActiveTab] = useState<string | null>(null);
    const [chatWidth] = useState<number>(() => {
        // Load stored width from localStorage on initial mount
        const storedWidth = localStorage.getItem('ept-chat-width');
        return storedWidth ? parseInt(storedWidth, 10) : 400;
    });
    const [updatedTabs, setUpdatedTabs] = useState<Set<string>>(new Set<string>());

    const getConversationsSchema = async (): Promise<void> => {
        try {
            const getidToken = await getIdTokenClaims();
            const idToken = getidToken?.__raw;
            const options: RequestInit = {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${idToken}`,
                    "Content-Type": "application/json",
                },
            };
            const path = `/admin/v1/pages/read/responses_admin`;
            const url = `${apiPath()}${path}`;
            const response = await fetch(url, options);
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const result = await response.json();
            if (result.tabs && result.tabs.length > 0 && result.tabs[0].card_list && result.tabs[0].card_list.length > 0) {
                if (result.tabs[0].card_list[0].title === "Loading...") {
                    setTimeout(() => {
                        getConversationsSchema();
                    }, 10000);
                }
            }
            setSchema(result);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching responses schema:', error);
            setIsLoading(false);
        }
    };
    
    useEffect(() => {
        if (user) {
            setIsLoading(true);
            setSchema(null);
            getConversationsSchema();
        }
    }, [user]);


       
    // Function to clear tab update indicator when tab is viewed
    const clearTabUpdateIndicator = (tabId: string): void => {
        setUpdatedTabs(prev => {
            const newSet = new Set(prev);
            newSet.delete(tabId);
            return newSet;
        });
    };
    
    
    const mainContentClassName = `main-content${isChatOpen ? ' chat-open' : ''}`;
    const mainContentStyle = isChatOpen ? { marginRight: `${chatWidth}px` } : {};

    return (
        <div>
            <MainAppWrap>
                <div className={mainContentClassName} style={mainContentStyle}>
                    {/* Header Section */}
                    {schema?.header  ? (
                    <SimpleHeader logo={schema?.header?.logo_url} title={schema?.header?.title} />
                ):(
                    <SimpleHeader />
                )}
                    <Container fluid="xxl" className="">
                        <Row>
                            <div className="page-container">
                            {isLoading ? <SettingsLoader /> : <PageRenderer 
                                schema={schema} 
                                activeTab={activeTab} 
                                setActiveTab={setActiveTab}
                                updatedTabs={updatedTabs}
                                clearTabUpdateIndicator={clearTabUpdateIndicator}
                            />}
                            </div>
                        </Row>
                    </Container>
                   
                </div>
                
                
                <ToastContainer />
                <Footer />
            </MainAppWrap>
        </div>
    );
};

export default ResponseList;